export default ".pointer {\n  cursor: pointer;\n}\n\n.fixe-end {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n}"